import { axios } from "@/lib/axios";
import { Bookable } from "@/types";

export const getBookableDisplay = ({ bookableId }: { bookableId: number }): Promise<Bookable> => {
  return axios.get(`/api/bookingDisplay/bookable/${bookableId}`);
};
